var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9257 28.9532H4.57145C3.76317 28.9532 2.988 28.6321 2.41646 28.0606C1.84492 27.4891 1.52383 26.7139 1.52383 25.9056V7.61988C1.52383 6.81161 1.84492 6.03643 2.41646 5.46489C2.988 4.89335 3.76317 4.57227 4.57145 4.57227H22.8572C23.6654 4.57227 24.4406 4.89335 25.0122 5.46489C25.5837 6.03643 25.9048 6.81161 25.9048 7.61988V13.7151",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2857 24.3823C18.2857 25.9989 18.9279 27.5493 20.071 28.6923C21.214 29.8354 22.7644 30.4776 24.3809 30.4776C25.9975 30.4776 27.5478 29.8354 28.6909 28.6923C29.834 27.5493 30.4762 25.9989 30.4762 24.3823C30.4762 22.7658 29.834 21.2154 28.6909 20.0724C27.5478 18.9293 25.9975 18.2871 24.3809 18.2871C22.7644 18.2871 21.214 18.9293 20.071 20.0724C18.9279 21.2154 18.2857 22.7658 18.2857 24.3823Z",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8095 1.52539V7.62063",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61905 1.52539V7.62063",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.52383 13.7148H25.9048",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.381 22.0898V24.3817L25.9048 25.9055",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTime);
export default __webpack_public_path__ + "static/media/calendar-time.749df0a6084a0de06d61729a46fc9ea8.svg";
export { ForwardRef as ReactComponent };